import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { TextSignInSignUp } from '../Components/TextSignInorSignUp';
import Modal from './Modal';

function SignUp() {
  const [input, setInput] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(true); // State to manage modal visibility
  const navigate = useNavigate();
  const handleChange = (e) => {
    let value = e.target.value;
    // let name = e.target.name;
    setInput(value);
    // console.log(input, name, value);
  };
  function handleNavigate() {
    if (input === 'Individual (or Corporate Individual)') {
      return navigate('renderci');
    } else if (input === 'Company (Organization)') {
      return navigate('/signup/company');
    } else {
      return;
    }
  }
  return (
    <div className='h-screen relative w-full max-w-md mx-auto'>
      {/* Modal for "Coming Soon" message */}
      <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />

      {/* The rest of the component will be hidden when the modal is open */}
      <div className={`${isModalOpen ? 'hidden' : 'block'}`}>
        <div className=' w-full pb-16 bg-p-wh flex items-center flex-col gap-8 border-hf border-t-bk rounded-lg absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 pt-16 px-6'>
          <h1 className='text-2xl font-rbs font-semibold text-p-bk'>Sign Up</h1>
          <form className='flex flex-col items-center gap-6 w-full box-border'>
            <div className='flex flex-col gap-2 w-full'>
              <p className='text-p-bk font-pin'>Register as?</p>
              <div className='flex items-center flex-col gap-6 w-full box-border'>
                <div className='flex h-11 items-center flex-row gap-3 w-full border-2 rounded-lg px-4'>
                  <input
                    type='radio'
                    className='w-4 border-4 h-11 border-s-bk'
                    name='registrationType'
                    id='individual'
                    value='Individual (or Corporate Individual)'
                    onChange={handleChange}
                  />
                  <label
                    htmlFor='individual'
                    className='text-p-bk text-base font-pin'
                  >
                    Individual (or Corporate Individual)
                  </label>
                </div>
                <div className='px-4 h-11 flex items-center flex-row gap-3 w-full rounded-lg border-2'>
                  <input
                    type='radio'
                    className='border-4 w-4 h-11  border-s-bk '
                    name='registrationType'
                    id='company'
                    value='Company (Organization)'
                    onChange={handleChange}
                  />
                  <label
                    htmlFor='company'
                    className='text-p-bk text-base font-pin'
                  >
                    Company (Organization)
                  </label>
                </div>
              </div>
            </div>

            <button
              className='text-p-wh px-4 py-2.5 w-full disabled:bg-f-bk m-4 font-semibold bg-b-mc rounded-lg'
              onClick={handleNavigate}
              disabled={!input}
            >
              Continue
            </button>
          </form>
          <TextSignInSignUp title='Sign In' question='Already have an account?' />
        </div>
      </div>
    </div>
  );
}
export default SignUp;
